/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.studio.backend.rpc.assetconfiguration.AssetConfigurationService
 */
import * as References from './AssetConfigurationService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.studio.backend.rpc.assetconfiguration.AssetConfigurationService#getAllAssetConfigurations
 */
export const GET_ALL_ASSET_CONFIGURATIONS_QUERY_FIELD_NAME = 'com_hubspot_studio_backend_rpc_assetconfiguration_AssetConfigurationService_getAllAssetConfigurations';
export const GET_ALL_ASSET_CONFIGURATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_ASSET_CONFIGURATIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllAssetConfigurationsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});